import { useRecoilState } from 'recoil'
import teamsTableAtom from './teamsTable.atom'
import useDebounce from 'shared/hooks/useDebounce'
import { useCallback } from 'react'
import teamsApi from 'screens/Teams/teams.api'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import teamsTableFields from './teamsTable.fields'
import { ITeam } from 'screens/Teams/teams.types'
import { useNavigate } from 'react-router-dom'
import SearchInput from 'shared/Inputs/SearchInput'
import Table from 'shared/Table'

interface IProps {
  onClick?: (team: ITeam) => void
}

const TeamsTable = (props: IProps) => {
  const navigate = useNavigate()
  const [usersTableState, setUsersTableState] = useRecoilState(teamsTableAtom)
  const debouncedSearch = useDebounce(usersTableState.filters.search, 400)

  const handleChange = (value: any, name: string) => {
    setUsersTableState((prev) => ({ ...prev, filters: { ...prev.filters, [name]: value } }))
  }

  const fetcher = useCallback(
    (params: Record<string, any>) => {
      return teamsApi.list({
        search: debouncedSearch,
        ...params,
      })
    },
    [debouncedSearch]
  )

  const itemsSetter = useItemsSetter(teamsTableAtom)

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: teamsTableFields,
    itemKey: 'id',
    items: usersTableState.items,
    setItems: itemsSetter,
    tableKey: 'roles',
    serverSideOrder: true,
  })

  const handleClick = useCallback((team: ITeam) => {
    navigate('/teams/' + team.id)
  }, [])

  return (
    <div className='flex-lines' style={{ height: '100%' }}>
      <div className='inline-flex-gap' style={{ gap: '8px', width: '100%' }}>
        <SearchInput
          value={usersTableState.filters.search}
          name='search'
          onChange={handleChange}
          required={false}
          placeholder='Поиск по наименованию'
          autofocus={true}
        />
      </div>
      <Table
        {...tableCtrl}
        items={tableCtrl.orderedItems}
        handleSelect={tableCtrl.selectedCtrl.setSelected}
        selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof ITeam>}
        handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
        itemKey='id'
        onCLick={props.onClick || handleClick}
        selectEnabled={false}
      />
    </div>
  )
}

export default TeamsTable
